/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Lab } from '../../models/lab';

export interface LabsGetDistinctTest$Params {
  patientId?: string | null;
  emrpracticeId?: string | null;
}

export function labsGetDistinctTest(http: HttpClient, rootUrl: string, params?: LabsGetDistinctTest$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Lab>>> {
  const rb = new RequestBuilder(rootUrl, labsGetDistinctTest.PATH, 'get');
  if (params) {
    rb.query('patientId', params.patientId, {});
    rb.query('emrpracticeId', params.emrpracticeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Lab>>;
    })
  );
}

labsGetDistinctTest.PATH = '/labs/DDlist';
